import React, { PropsWithChildren } from "react";
import { connect, FormikContext } from "formik";
import { Box, Button, Card, Flex, Text } from "rebass";

import { SubmitButton } from "../../../forms/components/SubmitButton";
import { SpinnerSVG } from "../../svg/SpinnerSVG";

type Values = {
  files: Array<string>;
}

interface IProps {
  formik: FormikContext<Values>;
}

const FormControlComponent: React.FC<IProps> = (
  {
    formik: {
      values: { files },
      isSubmitting,
      isValid,
      dirty ,
      handleReset,
    },
  }
) => (
  <Card
    p="18px"
    bg="#fff"
    borderTop="2px solid"
    borderTopColor="sp-gray"
    css="display: flex; justify-content: space-between;"
  >
    <Button
      type="button"
      px="26px"
      py="15px"
      border="1px solid"
      borderColor="hoki"
      borderRadius="5px"
      color="hoki"
      bg="transparent"
      fontSize="16px"
      fontWeight="bold"
      css="outline: none; text-transform: uppercase;"
      disabled={!dirty || isSubmitting}
      onClick={handleReset}
    >
      reset
    </Button>

    <SubmitButton
      width="auto"
      px="26px"
      py="15px"
      disabled={!isValid || isSubmitting}
    >
      <Flex alignItems="center">
        <Text as="span">import {files.length || undefined}</Text>

        {isSubmitting && (
          <Box ml="5px">
            <SpinnerSVG size={16} />
          </Box>
        )}
      </Flex>
    </SubmitButton>
  </Card>
);

export const FormControl = connect<PropsWithChildren<{}>, Values>(FormControlComponent);
